const dayjs = require('dayjs')

const filterTimes = (val, format = 'YYYY-MM-DD') => {
    if (!isNull(val)) {
        val = parseInt(val) * 1000
        return dayjs(val).format(format)
    } else {
        return '--'
    }
}

export const isNull = date => {
    if (!date) return true
    if (JSON.stringify(date) === '{}') return true
    if (JSON.stringify(date) === '[]') return true
}
export const toChinesNum = num => {
    const changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
    const unit = ['', '十', '百', '千', '万']
    num = parseInt(num)
    const getWan = temp => {
        const strArr = temp.toString().split('').reverse()
        let newNum = ''
        for (var i = 0; i < strArr.length; i++) {
            newNum =
                (i === 0 && strArr[i] === 0
                    ? ''
                    : i > 0 && strArr[i] === 0 && strArr[i - 1] === 0
                    ? ''
                    : changeNum[strArr[i]] + (strArr[i] === 0 ? unit[0] : unit[i])) + newNum
        }
        return newNum
    }
    const overWan = Math.floor(num / 10000)
    let noWan = num % 10000
    if (noWan.toString().length < 4) {
        noWan = '0' + noWan
    }
    return overWan ? getWan(overWan) + '万' + getWan(noWan) : getWan(num)
}

export const rankPedigree = (sex, rank) => {
    let rankP = ''
    let rankF = ''
    if (rank === 0) {
        rankP = '长'
    } else if (rank === 1) {
        rankP = '次'
    } else {
        rankP = toChinesNum(rank + 1)
    }
    switch (sex) {
        case 0:
            rankF = rankP + '子'
            break
        case 1:
            rankF = rankP + '女'
            break
    }
    return rankF
}
export const rankLevel = level => {
    return level + 1 + '世'
}
export default app => {
    app.config.globalProperties.$filters = {
        filterTimes
    }
}
